/**
 * SinRankCard component - Neo-Brutalist Design
 * Displays individual sin ranking with stats
 */

import type { SinRanking } from '../types';

interface SinRankCardProps {
  sin: SinRanking;
  rank: number;
}

export function SinRankCard({ sin, rank }: SinRankCardProps) {
  const isTopRank = rank <= 3;

  return (
    <div className={`sin-card ${isTopRank ? 'top-rank' : ''}`}>
      <div className="sin-card-content">
        {/* Rank Badge */}
        <div className={`rank-badge ${isTopRank ? 'top-rank' : ''}`}>
          #{rank}
        </div>

        {/* Sin Info */}
        <div className="sin-info">
          <div className="sin-name-row">
            <h3 className="sin-name">
              {sin.name}
            </h3>
            <span className={`severity-badge severity-${sin.severity}`}>
              {sin.severity}
            </span>
          </div>

          <p className="sin-description">{sin.description}</p>

          <div className="sin-stats">
            <div className="confession-count">
              <span className="count-number">{sin.count}</span>
              <span className="count-label">
                confession{sin.count !== 1 ? 's' : ''}
              </span>
            </div>

            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${sin.percentage}%` }}
              />
            </div>

            <div className="percentage">{sin.percentage.toFixed(1)}%</div>
          </div>
        </div>
      </div>
    </div>
  );
}
